import { z } from 'zod'

/**
 * 账户资料 API 响应 Schema（外部数据格式）
 */
export const AccountProfileResponseSchema = z.object({
  agent_id: z.string(),
  agent_name: z.string(),
  nickname: z.string().nullable(),
  promotion_code: z.string(),
  commission_rate: z.string(),
  is_disabled: z.boolean(),
  created_at: z.string(),
})

/**
 * 团队成员 API 响应 Schema
 */
export const TeamMemberResponseSchema = z.object({
  consumer_id: z.string(),
  nickname: z.string(),
  joined_at: z.string(),
})

/**
 * 团队成员列表 API 响应 Schema
 */
export const TeamMembersResponseSchema = z.object({
  consumers: z.array(TeamMemberResponseSchema),
})

/**
 * 推广链接 API 响应 Schema
 */
export const PromotionLinkResponseSchema = z.object({
  promotion_link: z.string(),
})

/**
 * 月度收益 API 响应 Schema
 */
export const MonthlyEarningsResponseSchema = z.object({
  monthly_revenue: z.string(),
})

/**
 * 上月营收 API 响应 Schema
 */
export const LastMonthRevenueResponseSchema = z.object({
  last_month_revenue: z.string(),
})

/**
 * 每日表现 API 响应 Schema
 */
export const DailyPerformanceResponseSchema = z.object({
  date: z.string(),
  revenue: z.string(),
})

/**
 * 近 7 日收益 API 响应 Schema
 */
export const Last7DaysRevenueResponseSchema = z.object({
  daily_revenue: z.array(DailyPerformanceResponseSchema),
})

/**
 * 登录结果 API 响应 Schema
 */
export const LoginResultResponseSchema = z.object({
  access_token: z.string(),
  agent_id: z.string(),
  duration_seconds: z.number(),
  token_type: z.string(),
})
